import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useAuth } from "../../../../hooks/useAuth";
import { useMasterData } from "../../../../hooks/useMasterData";
import SsoServices from "../../../../services/SsoServices";
import { MASTER_DATA } from "../../../../constants/api-constants";
import "./sso.css";
/*istanbul ignore next */
const SSOCallback = () => {
  const history = useHistory();
  const location = useLocation();
  const auth = useAuth();
  const masterDataContext = useMasterData();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchMasterData = async () => {
    try {
      const res = masterDataContext.masterDataValue;
      if (!res || Object.keys(res).length === 0) {
        const response = await SsoServices.ssoGet(MASTER_DATA);
        masterDataContext.setMasterData(response);
      }
      return true;
    } catch (e) {
      console.error("Failed to fetch master data:", e);
      return false;
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get("code");
    if (!code) {
      setError("The sign-in link is invalid or has expired. Please try again.");
      setLoading(false);
      return;
    }
    const doLogin = async () => {
      const result = await auth.ssoLogin(code);
      if (result.success) {
        await fetchMasterData();
        localStorage.removeItem("purchase_active_tab");

        // Redirect to cart if returnUrl contains "FolderRecieved"
        if (result.redirectToCart) {
          history.replace("/purchase/cart");
        } else {
          history.replace("/purchase");
        }
      } else {
        const errorMessage =
          result?.error ||
          "The sign-in link is invalid or has expired. Please try again.";
        setError(errorMessage);
        setLoading(false);
      }
    };

    doLogin();
  }, [location.search]);

  if (loading) {
    return (
      <div className="sso-loader-wrapper">
        <div className="sso-loader" />
        <p>Signing you in securely…</p>
      </div>
    );
  }

  return (
    <div className="sso-loader-wrapper">
      <p className="sso-error-text">{error}</p>
    </div>
  );
};

export default SSOCallback;
